import { useState, useEffect, useContext } from 'react';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { StoreContext } from '../Store';
import CustomerValidation from '../CustomerValidation';
import { useBusinessPartner } from './queryHooks/useBusinessPartner';

const LoadCustomerValidation = () => {
  const store = useContext(StoreContext);
  const navigate = useNavigate();
  const { id } = useParams();
  const { fetchBusinessPartnerStatus } = useBusinessPartner();

  const location = useLocation();
  const urlParams = new URLSearchParams(location.search);
  const from = urlParams.get('from');

  const [status, setStatus] = useState({
    id: null,
    companyName: '',
    cabieStatus: '',
    cabieStatusValid: false,
    dbStatus: '',
    dbStatusValid: false,
    billableCustomerValid: '',
    billableCustomer: false,
    cm8Approved: '',
    cm8ApprovedValid: false,
  });

  useEffect(() => {
    async function fetch() {
      try {
        const data = await fetchBusinessPartnerStatus(id);
        setStatus({
          id: data.id,
          companyName: data.companyName,
          cabieStatus: data.cabieStatus,
          cabieStatusValid: data.cabieStatusValid,
          dbStatus: data.dbStatus,
          dbStatusValid: data.dbStatusValid,
          billableCustomer: data.billableCustomer,
          billableCustomerValid: data.billableCustomerValid,
          cm8Approved: data.cm8Approved,
          cm8ApprovedValid: data.cm8ApprovedValid,
        });
      } catch (error) {
        console.error('Error fetching NBP list:', error);
      }
    }

    fetch();
  }, [id]);

  const cancelAction = () => {
    store.clientID[1](null);
    navigate(from === 'fileLoader' ? '/load/fileUpload' : '/load');
  };

  const createLoad = () => {
    store.clientID[1](id);
    navigate(`/load`);
  };

  const handleKebabClick = () => {
    store.clientID[1](id);
    const fromVar = from || 'build';
    navigate('/BusinessPartners?from=' + fromVar + '&id=' + status.id + '&companyid=' + id);
  };

  const customerIsLoadValid = status.cabieStatusValid && status.dbStatusValid && status.billableCustomerValid;

  return (
    <CustomerValidation
      isValid={customerIsLoadValid}
      companyName={status.companyName}
      companyId={status.id}
      onKebabClick={handleKebabClick}
      onCancel={cancelAction}
      onCreateLoad={createLoad}
      cabieStatusValid={status.cabieStatusValid}
      cabieStatus={status.cabieStatus}
      billableCustomerValid={status.billableCustomerValid}
      billableCustomer={status.billableCustomer}
      dbStatusValid={status.dbStatusValid}
      dbStatus={status.dbStatus}
      heading={`${store.newLoadFromFile[0] ? 'Import' : 'Build'} Your Load`}
    />
  );
};

export default LoadCustomerValidation;
